import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Helmet} from 'react-helmet';
import HomeSlider from "../Page/homeslider";
import PopularFlights from "../Page/PopularFlights";
import AboutUs from "../Page/AboutUs";
import Faqs from "../Page/Faqs";
import Newsletter from "../Page/Newsletter";
import PopularFlightsRoutes from "../Page/PopularFlightsRoutes";
import PopularHotels from "../Page/Hotels/Component/PopularHotels";
import BookTickets from "../Page/BookTickets";
import FlightDestinations from "../Page/FlightDestinations";
import PopularAirlines from "../Page/PopularAirlines";
import FlightsFrom from "../Page/FlightsFrom";
import FlightsWidgit from "../Page/FlightsWidgit";
import CheapFlights from "../Page/CheapFlights";
import Badge from "../Page/Badge";

function App1() {
  return (
   <>


  
    <Helmet>     
<title>Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com</title>
<meta name="description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time"/>
<meta name="keywords" content="Cheapflightsprices, Cheap Flights Prices,cheap flight booking, cheap flight fares,flight booking offer,Cheap Flights Prices,cheapest ticket booking,cheap price flight ticket, cheap price flight booking, flight ticket cheap price,dammam to trivandrum cheap flights prices"/>
<meta property="og:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta property="og:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta property="og:site_name" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:titlee" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<link rel="canonical" href="https://cheapflightsprices.com" />
        </Helmet>

   <section id="banner_section" className="flightbannersection">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-1 pb-0">Cheap Flights Booking Start <span>@ $24</span></h1>
        <p className="mb-4 pb-0">Enjoy Your Summer Vacation with Cheap Flights Prices & Checkout our Hotel deals to make your summer vacations a memorable</p>
<FlightsWidgit/>
    </div>
  </section>
<Badge/>
   
    <main id="main">

    <PopularFlights/>
    <FlightDestinations/>
    <PopularAirlines/>
    <PopularFlightsRoutes />
    <PopularHotels />
      

    <FlightsFrom/>
 {/*
   <section id="Cheapflights" className="section-with-bg">
      <div className="container" data-aos="fade-up">
            <div className="section-header">
          <h2><strong></strong></h2>
          <p></p>
        </div>
        <div className="designcontainer">
            <h2></h2>
            <p></p>
              </div>
      </div>
    </section>
 */}
    <Faqs/>
    <Newsletter/>
    
      </main>
     

    </>
  );
}
export default App1;
